// src/utils/createMultiWaferSVG.js (경고 해결 최종본)

// --- SVG Export 설정 상수 ---
const MAP_WIDTH = 450;
const MAP_HEIGHT = 450;
const PADDING = 25;
const MAPS_PER_ROW = 5;
// ✅ 사용되지 않는 BASE_CELL_SIZE 상수 제거

const SBIN_COLORS = (() => {
    const colors = { 1: "#4caf50" };
    for (let i = 2; i <= 100; i++) {
        colors[i] = `hsl(${(i * 30) % 360}, 70%, 60%)`;
    }
    return colors;
})();
const DEFAULT_COLOR = "#cccccc";

// 단일 웨이퍼 맵의 SVG 요소를 생성하는 헬퍼 함수
function createSingleWaferElements(mapData, waferInfo, offsetX, offsetY) {
    const { data, yld } = mapData;
    if (!data || data.length === 0) return '';

    const { minX, maxX, minY, maxY } = {
        minX: Math.min(...data.map(d => d.X)), maxX: Math.max(...data.map(d => d.X)),
        minY: Math.min(...data.map(d => d.Y)), maxY: Math.max(...data.map(d => d.Y)),
    };
    
    const PADDING_X_SVG = 20;
    const PADDING_Y_SVG = 55;
    
    const mapAreaWidth = MAP_WIDTH - PADDING_X_SVG;
    const mapAreaHeight = MAP_HEIGHT - PADDING_Y_SVG;
    const cellSize = Math.floor(Math.min(mapAreaWidth / (maxX - minX + 1), mapAreaHeight / (maxY - minY + 1)));
    if (cellSize <= 0) return '';

    const mapTotalWidth = (maxX - minX + 1) * cellSize;
    const mapTotalHeight = (maxY - minY + 1) * cellSize;
    const mapStartX = offsetX + PADDING_X_SVG / 2 + (mapAreaWidth - mapTotalWidth) / 2;
    const mapStartY = offsetY + PADDING_Y_SVG + (mapAreaHeight - mapTotalHeight) / 2;

    const dataMap = {};
    data.forEach(d => { dataMap[`${d.X},${d.Y}`] = d; });
    
    let elements = [];
    elements.push(`<text x="${offsetX + MAP_WIDTH / 2}" y="${offsetY + 15}" font-family="sans-serif" font-size="16px" font-weight="bold" fill="#000" text-anchor="middle">${waferInfo.LOT_ID} / ${waferInfo.WAFER_NO}</text>`);
    const yldText = (typeof yld === 'number') ? `(YLD: ${yld.toFixed(2)}%)` : "";
    elements.push(`<text x="${offsetX + MAP_WIDTH / 2}" y="${offsetY + 35}" font-family="sans-serif" font-size="14px" fill="#555" text-anchor="middle">${yldText}</text>`);

    for (let y = minY; y <= maxY; y++) {
        for (let x = minX; x <= maxX; x++) {
            const point = dataMap[`${x},${y}`];
            const px = mapStartX + (x - minX) * cellSize;
            const py = mapStartY + (y - minY) * cellSize;
            const fill = point ? (SBIN_COLORS[point.SBIN] || DEFAULT_COLOR) : "#fff";
            elements.push(`<rect x="${px}" y="${py}" width="${cellSize}" height="${cellSize}" fill="${fill}" stroke="#ccc" stroke-width="0.5" />`);
        }
    }
    
    return elements.join('');
}


// 메인 SVG 생성 함수
export default function createMultiWaferSVG(mapsToDraw) {
    if (!mapsToDraw || mapsToDraw.length === 0) {
        alert("저장할 맵 데이터가 없습니다.");
        return;
    }

    const totalRows = Math.ceil(mapsToDraw.length / MAPS_PER_ROW);
    const totalWidth = MAPS_PER_ROW * (MAP_WIDTH + PADDING) + PADDING;
    const totalHeight = totalRows * (MAP_HEIGHT + PADDING) + PADDING;

    let allSvgElements = [];

    mapsToDraw.forEach((map, index) => {
        const row = Math.floor(index / MAPS_PER_ROW);
        const col = index % MAPS_PER_ROW;
        const offsetX = col * (MAP_WIDTH + PADDING) + PADDING;
        const offsetY = row * (MAP_HEIGHT + PADDING) + PADDING;
        
        allSvgElements.push(`<rect x="${offsetX}" y="${offsetY}" width="${MAP_WIDTH}" height="${MAP_HEIGHT}" fill="white" stroke="#ccc" />`);
        allSvgElements.push(createSingleWaferElements(map.mapData, map.waferInfo, offsetX, offsetY));
    });

    const svgString = `<svg width="${totalWidth}" height="${totalHeight}" xmlns="http://www.w3.org/2000/svg" style="background-color: #f0f0f0;">${allSvgElements.join('')}</svg>`;
    
    const blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "WaferMaps.svg");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}